<template>
  <div class="wrap" v-if="!isLoading">
    <LogisticsState :logistic="logistic" :order="order" />
    <OrderInfo :order="order" :images="images" :itemInfo="itemInfo" />
    <div class="footer">
      <div class="btn" v-if="showAfterMarketBtn" @click="handleAfterMarket">
        售后进度
      </div>
      <div class="btn" @click="handleConsultService">咨询客服</div>
      <div
        class="btn primary"
        @click="handleReceivedMatter"
        v-if="showReceivedBtn"
      >
        确认收货
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  computed,
  ref,
} from "@vue/composition-api";
import Vue from "vue";

import { useRoute, useStore, useRouter } from "@/components/use/base";
import { getNamespaceBenefitImage, getOrderDetail } from "@/apis";
import { getLogisticDetail, receivedMatter } from "@/apis/matter";
import { getItemInfo } from "@/apis/home";
import { jsonSafeParse, getProjectDb } from "@/utils";

import OrderInfo from "./OrderInfo.vue";
import LogisticsState from "./LogisticsState.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    OrderInfo,
    LogisticsState,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const router = useRouter();

    const order_number = route.query.order_number;

    const namespace = computed(() => store.state.namespace);
    const showReceivedBtn = computed(() => {
      if (
        order.value.status === "refund" ||
        order.value.status === "canceled" ||
        ["pending", "reviewing", "returning", "receiving", "received"].includes(
          logistic.value.refund_status
        )
      )
        return false;
      if (
        order.value.status === "confirming" &&
        ["paid", "unpaid"].includes(logistic.value.status)
      )
        return false;
      if (["success", "failed"].includes(order.value.status)) return false;
      return true;
    });

    const showAfterMarketBtn = computed(() => {
      if (!logistic.value.activate_refund_number) return false;
      if (
        ["pending", "reviewing", "returning", "receiving", "received"].includes(
          logistic.value.refund_status
        )
      )
        return true;
      return false;
    });

    const order = ref({});
    const logistic = ref({});
    const images = ref([]);
    const isLoading = ref(false);
    const itemInfo = ref({});

    onMounted(async () => {
      const loading = vm.$loading();
      try {
        isLoading.value = true;
        await fetchOrderDetail();
        await fetchLogisticDetail();
      } catch (error) {
        console.log(error);
      } finally {
        loading.close();
        isLoading.value = false;
      }
    });

    const fetchOrderDetail = async () => {
      const { data: orderData } = await getOrderDetail({ order_number });
      const { data: imagesData } = await getNamespaceBenefitImage({
        namespace_en: namespace.value,
        product_code: orderData.type,
      });
      order.value = orderData;
      images.value = imagesData;
      const payInfo = jsonSafeParse(orderData.pay_info);
      const res = await getItemInfo({
        item_code: payInfo.item_code,
        benefit_type: orderData.type,
        project_db: getProjectDb(namespace.value),
      });
      itemInfo.value = res;
    };

    const fetchLogisticDetail = async () => {
      const { data: logisticData } = await getLogisticDetail(
        order.value.order_number
      );
      logistic.value = logisticData || {};
    };

    const handleAfterMarket = () => {
      router.push(
        `/matterAfterMarket?orderNumber=${order.value.order_number}&refundNumber=${logistic.value.activate_refund_number}`
      );
    };

    const handleReceivedMatter = async () => {
      vm.$confirm({
        message: "确定收货吗？",
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then(async () => {
        await receivedMatter({
          order_number: order.value.order_number,
        });
        await fetchOrderDetail();
        await fetchLogisticDetail();
      });
    };

    const handleConsultService = () => {
      router.push(
        `/service?order_number=${order.value.order_number}&from=order`
      );
    };

    return {
      order,
      images,
      logistic,
      isLoading,
      showReceivedBtn,
      showAfterMarketBtn,
      itemInfo,
      handleReceivedMatter,
      handleConsultService,
      handleAfterMarket,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  background-color: rgb(245, 245, 245);
  min-height: 100vh;
  padding: 12px;
  box-sizing: border-box;
  position: relative;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 51px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .btn {
    margin-right: 10px;
    border-radius: 17px;
    border: 1px solid #bbbbbb;
    width: 78px;
    height: 28px;

    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 28px;
    text-align: center;

    &.primary {
      background: #fa6400;
      border: 1px solid #fa6400;
      color: #ffffff;
    }
  }
}
</style>
